import { SVGProps } from 'react';

const FromVinIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg height="20" width="20" fill="none" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M15.0021 11.6674C16.8438 11.6674 18.3368 13.1604 18.3368 15.0021C18.3368 16.8438 16.8438 18.3368 15.0021 18.3368C13.1604 18.3368 11.6674 16.8438 11.6674 15.0021C11.6674 13.1604 13.1604 11.6674 15.0021 11.6674"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M16.1259 14.441L14.722 15.8491L13.8783 15.0021"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M6.93541 9.55899H5.16968"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M14.0458 9.55899H12.28"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M14.9287 6.91033L16.6936 6.02747"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M4.28673 6.91033L2.521 6.02747"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M6.73533 2.49683C5.91487 2.49691 5.20246 3.06187 5.01545 3.86073L4.26514 7.06206L5.01545 3.86073C5.20246 3.06187 5.91487 2.49691 6.73533 2.49683H12.4802C13.3006 2.49668 14.0129 3.06182 14.1993 3.86073L14.9496 7.06206"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M16.6936 10V9.34143C16.6936 8.03834 15.6382 6.98145 14.3351 6.97961H4.88365C4.25711 6.97939 3.65616 7.22813 3.21305 7.67108C2.76994 8.11403 2.521 8.71489 2.521 9.34143V13.3348C2.521 13.7952 2.89425 14.1684 3.35468 14.1684H5.21879C5.67922 14.1684 6.05247 13.7952 6.05247 13.3348V12.2068H9.99994"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export default FromVinIcon;
